import { Billing } from 'one-state-billing-details-athena';
import { formatIso } from 'one-util-date';
const  athenapatientrelationship: { [key: string]: string } = {
    "1": "Self",
    "2": "Spouse",
    "3": "Parent",
    "4": "Other",
    "5": "Grandchild",
    "6": "Grandparent",
    "7": "Uncle or Aunt",
    "9": "Foster Parent",
    "10": "Guardian",
    "11": "Stepmother or Stepfather",
    "12": "Employer",
    "13": "Unknown",
    "14": "n/a",
    "15": "n/a",
    "16": "n/a",
    "17": "Significant Other",
    "18": "Child",
    "19": "Child",
    "21": "n/a",
    "22": "n/a",
    "23": "n/a",
    "24": "n/a",
    "25": "Stepmother or Stepfather",
    "26": "Life Partner",
    "27": "Parent",
    "28": "Parent",
    "29": "Parent",
    "30": "Parent",
    "31": "Stepmother or Stepfather",
    "32": "Stepmother or Stepfather"
  };
export const TransformBillingDetails = (response: any, context: any) => {
    let billing: Billing = {
        patientsGuarantor: false,
        AccountName: "",
        GuarantorName: "",
        GuarantorRelation: "",
        Guarantorrelationid: "",
        balanceDetails: {
            patientBalance: "0",
            insuranceBalance: "0"
        },
        claimdetails: [],
    };

    let billingresult: any = {
        billingdata: billing,
        error: undefined
    };

    const { log, settings } = context;
    const { uisettings: { dateformat } } = settings;

    log.debug("one-athena-billing-checking", "TransformBillingDetails transformation entered check", response);

    if (response && (response.status >= 400 || response.type === "error")) {
        billingresult.error = response;
        return billingresult;
    }

    if (response && typeof response === "object") {
        const res = response;
        let totalPatientBalance = 0;
        let totalInsuranceBalance = 0;

        billing.AccountName = [res?.firstname, res?.lastname].filter(Boolean).join(" ");
        billing.patientsGuarantor = res?.guarantorrelationshiptopatient !== "1";
        billing.GuarantorName = [res?.guarantorfirstname, res?.guarantorlastname].filter(Boolean).join(" ");
 
        billing.GuarantorRelation = athenapatientrelationship[res?.guarantorrelationshiptopatient] || "";
        billing.Guarantorrelationid = res?.guarantorrelationshiptopatient || "";

        if (Array.isArray(res?.claimbalancedetails)) {
            res.claimbalancedetails.forEach((account: any) => {
                if (!Array.isArray(account?.claimdetails)) return;

                account.claimdetails.forEach((claim: any) => {
                    const diagnoses = Array.isArray(claim?.claimDetails?.diagnoses)
                        ? claim.claimDetails.diagnoses
                        : [];
                    const uniqueDiagnoses = new Set(
                        diagnoses.map((d: any) => d?.diagnosisdescription).filter(Boolean)
                    );
                    const description = Array.from(uniqueDiagnoses).join(", ");

                    const chargeLevelDetails = Array.isArray(claim?.chargeleveldetail)
                        ? claim.chargeleveldetail.map((detail: any) => ({
                            servicedate: formatIso(detail?.servicedate || claim?.servicedate, dateformat),
                            procedurecode: detail?.procedurecode || "",
                            description: detail?.description || "",
                            amount: detail?.amount || 0
                        }))
                        : [];

                    billing.claimdetails.push({
                        claimId: claim?.claimid ? String(claim.claimid) : "",
                        date: formatIso(claim?.servicedate, dateformat),
                        patientBalance: "$" + parseFloat(claim?.totalClaimPatientBalance || "0").toLocaleString('en-US'),
                        insuranceBalance: "$" + parseFloat(claim?.totalClaimInsuranceBalance || "0").toLocaleString('en-US'),
                        departmentName: claim?.departmentDetails?.name || "",
                        providerName: claim?.departmentDetails?.providergroupname || "",
                        description,
                        chargeLevelDetails,
                        renderingProviderName: claim?.renderingProviderDetails.schedulingname || "",
                        supervisingProviderName: claim?.supervisingProviderDetails.schedulingname || ""
                    });
                });

                totalPatientBalance += parseFloat(account?.patientBalance || "0");
                totalInsuranceBalance += parseFloat(account?.insuranceBalance || "0");
            });
        }

        billing.balanceDetails.patientBalance = totalPatientBalance.toLocaleString('en-US');
        billing.balanceDetails.insuranceBalance = totalInsuranceBalance.toLocaleString('en-US');
    }

    billingresult.billingdata = billing;
    log.debug("one-athena-billing", "TransformBillingDetails transformation Completed", billingresult);
    return billingresult;
};
